export const contexts: CampaignContext[] = [
  'home',
  'category',
  'search',
  'product_page',
  'brand_page'
]

// DD/MM/YYYY — data real do cutoff de atribuição de ROAS.
export const ROAS_CUTOFF_DATE = '01/07/2026'
export const ROAS_ATTRIBUTION_MARKER_TYPE = 'roasAttributionCutoff'

export const formatRoasCutoffDate = (locale: string): string => {
  const [day, month, year] = ROAS_CUTOFF_DATE.split('/')
  const date = new Date(Number(year), Number(month) - 1, Number(day))
  return new Intl.DateTimeFormat(locale, {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  }).format(date)
}

// Janela de lookback NTB padrão em toda superfície (FR-019a)
export const DEFAULT_NTB_LOOKBACK_MONTHS = 12

// Aceita só inteiro positivo; qualquer outra coisa cai no padrão
export const parseLookbackMonths = (value: unknown): number => {
  const parsed = Number(value)

  return Number.isInteger(parsed) && parsed > 0
    ? parsed
    : DEFAULT_NTB_LOOKBACK_MONTHS
}
